import { Role as CustomerRole } from "src/network/User";

export const canManageCustomerPassword = (
    userRole: CustomerRole | undefined,
    availableRoles: CustomerRole[] = []
) => userRole === CustomerRole.CUSTOMERDEV || availableRoles.includes(CustomerRole.CUSTOMER2NDLEVEL);

export const getCustomerPasswordRole = (
    userRole: CustomerRole | undefined,
    availableRoles: CustomerRole[] = []
) => (availableRoles.includes(CustomerRole.CUSTOMER2NDLEVEL) ? CustomerRole.CUSTOMER2NDLEVEL : userRole);
